var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "common-nav-bar" }, [
    _c("div", { staticClass: "menu-wrapper" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.isAdminPremium
        ? _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "chocolate" } },
            [_vm._v("PREMIUM")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobileNav
        ? _c(
            "div",
            {
              staticClass: "menu-toggle",
              on: {
                click: function ($event) {
                  _vm.isMenuOpened = !_vm.isMenuOpened
                },
              },
            },
            [
              _c("img", {
                staticClass: "icon-toggle",
                attrs: { src: _vm.menuIcon },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "toggle-title" }, [
                _vm._v(_vm._s(_vm.menuTitle)),
              ]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.isMenuVisible
      ? _c(
          "div",
          { ref: "menuContainer", staticClass: "nav-buttons-wrapper" },
          [
            _c("div", { staticClass: "account-menu-wrapper" }, [
              _c("div", { staticClass: "premium-wrapper" }, [
                !_vm.showPremium
                  ? _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("rt-picture", {
                          staticClass: "icon-premium",
                          attrs: {
                            src: "/assets/app/navigation/icon-diamond.svg",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPremium
                  ? _c(
                      "div",
                      {
                        staticStyle: { display: "flex" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("pemiumButtonClicked")
                          },
                        },
                      },
                      [
                        _c("rt-picture", {
                          staticClass: "icon-premium",
                          attrs: {
                            src: "/assets/app/navigation/icon-diamond.svg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Try premium")]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "account-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "account-button-wrapper",
                    on: { click: _vm.handleShowAccountDropdown },
                  },
                  [
                    _c("user-avatar", {
                      attrs: {
                        isProfileAvatar: true,
                        userName: _vm.username,
                        userIcon: _vm.userIcon,
                        avatarColor: _vm.avatarColor,
                      },
                    }),
                    _vm._v(" "),
                    !_vm.isMobileNav
                      ? _c("img", {
                          staticClass: "dropdown-icon",
                          attrs: { src: _vm.dropdownIcon },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isDropdownVisible
                  ? _c(
                      "div",
                      {
                        class: {
                          "dropdown-menu": true,
                          "teacher-menu": _vm.isTeacherNav,
                          premium: _vm.showPremium,
                        },
                      },
                      [
                        _vm._l(_vm.dropdownButtons, function (dropdown, idx) {
                          return _c(
                            "div",
                            { key: idx + _vm.dropdownButtons.length },
                            [
                              !dropdown.separate_line
                                ? _c(
                                    "a",
                                    {
                                      class: {
                                        "dropdown-button": true,
                                        premium: dropdown.type === "premium",
                                        active:
                                          dropdown.name === _vm.currentNavName,
                                      },
                                      attrs: { href: dropdown.href },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClickDropdown(
                                            dropdown.type,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-icon-wrapper",
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "button-icon",
                                            attrs: {
                                              src: _vm.getNavIconPath(
                                                dropdown.icon,
                                                !dropdown.no_hover &&
                                                  dropdown.name ===
                                                    _vm.currentNavName
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "button-title" },
                                        [_vm._v(_vm._s(dropdown.name))]
                                      ),
                                    ]
                                  )
                                : _c("div", { staticClass: "separate-line" }),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.showPremium
                          ? _c(
                              "div",
                              { staticClass: "premium-menu-wrapper" },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "primary-button",
                                  {
                                    staticClass: "btn-choose-plan",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("pemiumButtonClicked")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/assets/app/navigation/icon-diamond.svg",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Choose your plan")]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "navs-wrapper" },
              _vm._l(_vm.leftNavButtons, function (nav, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass: "nav-item-wrapper",
                    attrs: { title: nav.name },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: {
                          "navigation-button": true,
                          active: nav.name === _vm.currentNavName,
                        },
                        attrs: { href: nav.href },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "nav-icon-wrapper",
                            class: {
                              challenge: nav.icon === "reading-challenge",
                            },
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.getNavIconPath(nav.icon) },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "button-title" }, [
                          _vm._v(_vm._s(nav.name)),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.isMobileNav
              ? _c(
                  "div",
                  { staticClass: "navs-wrapper right-navs" },
                  _vm._l(_vm.dropdownButtons, function (nav, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "nav-item-wrapper",
                        attrs: { title: nav.name },
                      },
                      [
                        _c(
                          "a",
                          {
                            class: {
                              "navigation-button": true,
                              active: nav.name === _vm.currentNavName,
                            },
                            attrs: { href: nav.href },
                            on: {
                              click: function ($event) {
                                return _vm.handleClickDropdown(nav.type, $event)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "button-title" }, [
                              _vm._v(_vm._s(nav.name)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showActivityRibbon
      ? _c(
          "div",
          { ref: "activityRibbonRef", staticClass: "activity-ribbon-wrapper" },
          [
            _c(
              "div",
              { staticClass: "activity-ribbon" },
              [
                _c("span", [
                  _vm._v(
                    "ReadTheory Knowledge Week Competition is starting now!"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/app/teacher/activities?create_global_competiton=true",
                    },
                    on: { click: _vm.reportActivityEvent },
                  },
                  [_vm._v("Click here to join")]
                ),
                _vm._v(" "),
                _c(
                  "primary-button",
                  {
                    staticClass: "btn-normal",
                    on: { click: _vm.handleClickCloseActivityRibbon },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/assets/app/class/icon-closed.svg" },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showSalesRibbon
      ? _c(
          "div",
          { ref: "salesRibbonRef", staticClass: "sales-ribbon-wrapper" },
          [
            _c(
              "div",
              { staticClass: "sales-ribbon" },
              [
                _c("span", [
                  _vm._v(
                    "NOVEMBER SALE | Get 50% Off Premium Subscriptions Now!"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onShowSubscribe")
                      },
                    },
                  },
                  [_vm._v("Subscribe")]
                ),
                _vm._v(" "),
                _c(
                  "primary-button",
                  {
                    staticClass: "btn-normal",
                    on: { click: _vm.handleClickCloseRibbon },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/assets/app/class/icon-closed.svg" },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "header-link", attrs: { href: "/", title: "Home" } },
      [
        _c("img", {
          staticClass: "nav-heder-icon",
          attrs: { src: "/assets/app/quiz/icon-header-logo.svg" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "premium-description" }, [
      _vm._v("Subscribe to the "),
      _c("b", [_vm._v("Premium plan")]),
      _vm._v(" to open more functions."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }